<template>
  <ContentDetailWrap @back="$router.back()">
    <div class="wrap">
      <div class="title title-mb">
        <div class="title-block">
          <div class="block"></div>
          <div class="titleText">计划信息</div>
        </div>
        <div>
          <span>采购计划单号：</span>
          <span>{{ purchasePlanData.bizNo }}</span>
        </div>
      </div>

      <TablePublic
        :colLists="colLists"
        :tableData="tableData"
        :showIndex="false"
        :paginationFlag="false"
      >
        <template slot="percentage" slot-scope="scope">
          <div class="progress">
            <el-progress
              color="#c59429"
              :stroke-width="10"
              type="circle"
              :percentage="scope.data.percentage"
            ></el-progress>
          </div>
        </template>
      </TablePublic>

      <div class="title title-mb title-mt">
        <div class="title-block">
          <div class="block"></div>
          <div class="titleText">采摘批次</div>
        </div>
        <div>
          <span>采摘批次：</span>
          <span>{{ pickDetail.bizNo }}</span>
        </div>
      </div>
      <TablePublic
        :colLists="colLists2"
        :tableData="tableData1"
        :paginationFlag="false"
        :showIndex="false"
      ></TablePublic>

      <div class="title title-mb title-mt">
        <div class="title-block">
          <div class="block"></div>
          <div class="titleText">派发任务信息</div>
        </div>
      </div>
      <TablePublic
        :colLists="colLists4"
        :tableData="tableData1"
        :paginationFlag="false"
        :showIndex="false"
      ></TablePublic>

      <div class="title title-mt title-mb">
        <div class="title-block">
          <div class="block"></div>
          <div class="titleText">历史修改记录</div>
        </div>
      </div>
      <TablePublic :colLists="colLists3" :tableData="tableData3" :paginationFlag="false">
        <template slot="modificationDesc" slot-scope="scope">
          <el-tooltip
            :disabled="!scope.data.modificationDesc"
            :content="scope.data.modificationDesc"
            placement="top"
            popper-class="custom-tooltip-width"
          >
            <div class="modificationDesc">{{ scope.data.modificationDesc }}</div>
          </el-tooltip>
        </template>
      </TablePublic>
      <Box :row="pickDetail"></Box>
    </div>
  </ContentDetailWrap>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import {
  getPurchasePlanDetail,
  getPickBatchDetail,
  getAmdRecList,
  getPickingBatchTaskDetail,
} from '@/api/system/manage'
import TablePublic from '@/components/tablePublic'
import Box from '@/components/nameBox.vue'
import ContentDetailWrap from '@/components/ContentDetailWrap.vue'
export default {
  components: { TablePublic, Box, ContentDetailWrap },
  data() {
    const _this = this
    return {
      title: '',
      loading: false,
      dialogVisible: false,
      form: {
        reqList: [],
      },
      pickDetail: {},
      colLists: [
        {
          prop: 'code',
          label: '',
          isTrue: true,
          children: [
            {
              prop: 'index',
              label: '序号',
              isTrue: true,
              width: '55',
            },
            {
              prop: 'cultivationMethodSpecValueKey',
              label: '培育方式',
              isTrue: true,
            },
            {
              prop: 'ripenessLevelSpecValueKey',
              label: '成熟度',
              isTrue: true,
            },
            {
              prop: 'planToPurchaseNetWeight',
              label: '计划采购总净重(斤)',
              isTrue: true,
            },
            {
              prop: 'purchasedNetWeight',
              label: '已计划采摘总净重(斤)',
              isTrue: true,
            },
            {
              prop: 'percentage',
              label: '已计划采摘进度',
              isTrue: true,
              formSolt: true,
            },
          ],
        },
      ],
      colLists2: [
        {
          prop: 'bizNo',
          label: '采摘批次',
          isTrue: true,
          width: '120',
        },
        {
          prop: 'plantationBizNo',
          label: '果园编号',
          isTrue: true,
          width: '118',
        },
        {
          prop: 'plantationName',
          label: '果园名称',
          isTrue: true,
          width: '130',
        },
        {
          prop: 'locName',
          label: '果园区域',
          isTrue: true,
          width: '130',
        },
        {
          prop: 'cultivationMethodSpecValueKey',
          label: '培育方式',
          isTrue: true,
          width: '130',
        },
        {
          prop: 'cropAgeValue',
          label: '果树树龄(年)',
          isTrue: true,
          width: '130',
        },
        {
          prop: 'ripenessLevelSpecAttrValueKey',
          label: '成熟度',
          isTrue: true,
          width: '130',
        },
        {
          prop: 'planToPickTotalQuantity',
          label: '计划采摘总筐数',
          isTrue: true,
          width: '150',
        },
        {
          prop: 'plannedNetWeightPerUnit',
          label: '计划单筐净重(斤)',
          isTrue: true,
          width: '150',
        },
        {
          prop: 'planToPickTotalNetWeight',
          label: '计划采摘总净重(斤)',
          isTrue: true,
          width: '160',
        },
        {
          prop: 'unitPrice',
          label: '单价(元)',
          isTrue: true,
          width: '150',
          formatter(row) {
            return _this.formatPrice(row.unitPrice)
          },
        },
        {
          prop: 'totalAmount',
          label: '合计(元)',
          isTrue: true,
          formatter(row) {
            return _this.formatPrice(row.totalAmount)
          },
        },
        {
          prop: 'processFactoryName',
          label: '加工厂',
          isTrue: true,
        },
        {
          prop: 'warehouseName',
          label: '仓库',
          isTrue: true,
        },
        {
          prop: 'storageArea',
          label: '库区',
          isTrue: true,
        },
        {
          prop: 'fertilizerTypeKeyValue',
          label: '施肥种类',
          isTrue: true,
        },
        {
          prop: 'fieldTypeKeyValueList',
          label: '土地性质',
          isTrue: true,
          width: '100',
        },
        {
          prop: 'ownerName',
          label: '园主/场长',
          isTrue: true,
          width: '110',
        },
        {
          prop: 'ownerContact',
          label: '联系方式',
          isTrue: true,
          width: '140',
        },
      ],
      visible: false,
      colLists3: [
        {
          prop: 'modificationDesc',
          label: '修改内容',
          isTrue: true,
          formSolt: true,
          align: 'left',
        },
        {
          prop: 'reason',
          label: '修改原因',
          isTrue: true,
          align: 'left',
        },
        {
          prop: 'createDate',
          label: '修改日期',
          isTrue: true,
          width: '100',
        },
        {
          prop: 'createBy',
          label: '修改人',
          isTrue: true,
          width: '100',
        },
      ],
      colLists4: [
        {
          prop: 'pickingDate',
          label: '采摘日期',
          isTrue: true,
        },
        {
          prop: 'supervisor',
          label: '监园人员',
          isTrue: true,
        },
        {
          prop: 'remark',
          label: '备注',
          isTrue: true,
        },
      ],
      tableData3: [],
      tableData2: [],
      tableData1: [],
      tableData: [],
    }
  },
  computed: {
    ...mapState({
      purchasePlanData: (state) => state.manage.infoDetail || {},
      dictList: (state) => state.system.dictList || [],
    }),
  },
  created() {
    this.pickId = this.$route.query.id
    this.getDictList({ types: 'ripenessLevel, cultivationMethod, fertilizerType, landStatus, productType' })
    this.getPlanDetail()
    this.getPickDetail()
    this.getAmdRecList()
  },
  methods: {
    ...mapActions({ getDictList: 'system/getDictList' }),

    getPlanDetail() {
      getPurchasePlanDetail(this.purchasePlanData.id).then((res) => {
        if (res.flag) {
          this.colLists[0].label = res.data.name
          this.tableData = res.data.itemRespList.map((d, index) => {
            d.index = index + 1
            d.percentage = this.myFixed((d.purchasedNetWeight / d.planToPurchaseNetWeight) * 100, 2) || 0
            return d
          })
        }
      })
    },
    getPickDetail() {
      getPickBatchDetail(this.pickId).then((res) => {
        if (res.flag) {
          this.tableData1 = []
          let row = res.data
          this.pickDetail = row
          if (row) {
            row.locName = this.formatLocal(row.locDetails, 3)
            row.supervisor = JSON.parse(row.supervisorIdList || '[]')
              .map((item) => item.userName)
              .join(',')
            row.pickingDate = this.parseTime(row.pickingDateTime, '{y}-{m}-{d}')
            this.tableData1.push(row)
          }
        }
      })
    },
    getAmdRecList() {
      getAmdRecList({ formId: this.pickId, formType: 'picking_batch' }).then((res) => {
        if (res.flag) {
          this.tableData3 = res.data.map((d) => {
            d.createDate = this.parseTime(d.createTime, '{y}-{m}-{d}')
            return d
          })
        }
      })
    },
  },
}
</script>

<style scoped lang='less'>
@import '../../../assets/form.less';
.wrap {
  height: 780px;
  overflow: auto;
}
/deep/ .delbutton.el-button--text {
  color: red;
}
.progress {
  height: 48px;
  display: flex;
  justify-content: center;
}
/deep/ .el-progress-circle {
  width: 48px !important;
  height: 48px !important;
}
/deep/ .el-progress__text {
  font-size: 12px !important;
}
.progress {
  margin-bottom: 0px;
  padding-bottom: 0px;
}
/deep/ .line-button {
  background-color: #c59429;
  color: #ffffff;
  border-color: #c59429;
  margin-left: 20px;
}
.batch-button {
  position: fixed;
  right: 20px;
  bottom: 80px;
}
/deep/ .el-card__body,
.el-main {
  padding: 10px 20px;
}
</style>